import { html } from "lit";
var icon_back_default = () => html`
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
    <path
      d="M18.12 9.67c0-.4-.33-.71-.73-.71h-13l4.65-4.6a.72.72 0 00.22-.5A.74.74 0 008 3.33L2.1 9.17h-.02l-.02.03-.03.03-.01.02-.03.04-.01.03-.02.03-.02.03-.01.03-.02.04v.03l-.02.04v.03l-.01.04v.23l.02.03v.03l.02.05v-.01.03l.02.04.03.06v-.01l.03.05.02.02a.5.5 0 00.04.05l.03.04 5.9 5.83a.74.74 0 001.27-.51v-.02c0-.2-.09-.37-.22-.5l-4.65-4.6h12.99c.41 0 .74-.32.74-.73z"
      fill-rule="evenodd" />
  </svg>
`;
export {
  icon_back_default as default
};
//# sourceMappingURL=icon-back.js.map
